import { useEffect, useMemo, useRef, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetAdByIdData, GetAdByUserIdData, GetAdsData, GetAdsExportData, GetCategoriesData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { adsColumns, typeOfAds, typeOfcurrency, typeOfUsers } from "../../lib/definitions";
// Make sure to add boostAdsForm to your actions file
import { deleteAdsForm, boostAdsForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useLocation, useParams, useSearchParams, useNavigate } from "react-router-dom";
import { MdOutlineFileUpload, MdAddCircleOutline } from "react-icons/md";
import AdsDetailsPop from "../../ui/adsUi/adsDetails";
import AdsFilter from "../../ui/searchFilter/adsFilter";
import NotData from "../../ui/sharedUi/noData";
import i18n from "../../lib/i18n";
import toast from "react-hot-toast"; // Assuming you use toast for notifications

export default function Ads({userName}) {
    const [searchParams] = useSearchParams();
    const deleteRef = useRef(null);
    const adsRef = useRef(null);
    const boostRef = useRef(null); // Ref for the boost popup

    const [adsData, setAdsData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [adsDetails, setAdsDetails] = useState({});
    const [categoriesParentDataFilter, setCategoriesParentDataFilter] = useState([]);
    const [categoriesChildDataFilter, setCategoriesChildDataFilter] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [openDetails, setOpenDetails] = useState({ isOpen: false, idToOpen: null });
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    
    // --- BOOST POPUP STATES ---
    const [boostConfirmation, setBoostConfirmation] = useState({ 
        isOpen: false, 
        idToBoost: null, 
        title: "", 
        userName: "", 
        isBoosted: false, 
        startDate: null, 
        endDate: null 
    });
    const [durationDays, setDurationDays] = useState(0);
    const [loadingBoost, setLoadingBoost] = useState(false);

    const [isLoading, setIsLoading] = useState(true);  
    const [showExportDialog, setShowExportDialog] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false); 
    const location = useLocation(); 
    
    const category_id = searchParams.get('category_id');
    const sub_category_id = searchParams.get('sub_category_id');
    const minPrice = searchParams.get('minPrice');
    const maxPrice = searchParams.get('maxPrice');
    const from_date = searchParams.get('from_date');
    const to_date = searchParams.get('to_date');
    const orderStatus = searchParams.get('orderStatus');
    const typePublisher = searchParams.get('typePublisher');
    const id = searchParams.get('id');
    const currency = searchParams.get('currency');
    const t = i18n.t.bind(i18n); 

    const {userId} = useParams();
    const navigate = useNavigate();
    const currentLang = i18n.language;

    const params = useMemo(() => {
        const tempParams = [];
        if (category_id) tempParams.push({ category_id });
        if (sub_category_id) tempParams.push({ sub_category_id });
        if (minPrice) tempParams.push({ minPrice });
        if (maxPrice) tempParams.push({ maxPrice });
        if (from_date) tempParams.push({ from_date });
        if (to_date) tempParams.push({ to_date });
        if (orderStatus) tempParams.push({ orderStatus });
        if (currency) tempParams.push({ currency });
        if (id) tempParams.push({ id });
        if (typePublisher) tempParams.push({ typePublisher });

        return tempParams;
    }, [ sub_category_id, category_id, minPrice, maxPrice, from_date, to_date, typePublisher, currency, orderStatus, id]);

    useEffect(() => {
        handleApi();
    }, [currentPage, params])

    // Outside click for Delete
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (deleteRef.current && !deleteRef.current.contains(event.target)) {
                closeDeleteConfirmation();
            }
        };
        if (deleteConfirmation.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        };
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [deleteConfirmation.isOpen]);

    // Outside click for Details
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (adsRef.current && !adsRef.current.contains(event.target)) {
                onClose();
            }
        };
        if (openDetails.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        };
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [openDetails.isOpen]);

    // Outside click for Boost Popup
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (boostRef.current && !boostRef.current.contains(event.target)) {
                closeBoostConfirmation();
            }
        };
        if (boostConfirmation.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        };
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [boostConfirmation.isOpen]);

    useEffect(() => {
        handleFilterCategoryParent();
        handleFilterCategoryChlid();
    }, [])

    const handleApi = async () => {
        setIsLoading(true); 
        let adsData = [];
        if(location.pathname.startsWith("/users/details/")){
            adsData = await GetAdByUserIdData(userId, currentPage, params);
            setAdsData([]);
            adsData.data.Ads.map((e) => setAdsData((prev) => [...prev, e]));
            setcurrentPage(adsData?.pagination?.current_page);
            setlast_page(adsData?.pagination?.last_page);
        }
        else {
            adsData = await GetAdsData(currentPage, params);
            setAdsData([]);
            adsData.data.map((e) => setAdsData((prev) => [...prev, e]));
            setcurrentPage(adsData?.pagination?.current_page);
            setlast_page(adsData?.pagination?.last_page);
        };
        setIsLoading(false);  
    };

    const handleFilterCategoryParent = async () => {
        const params = [ {"status" : "main"} ];
        const categoriesDataFilter = await GetCategoriesData(1, params);
        setCategoriesParentDataFilter([]);
        categoriesDataFilter.data.map((e) => setCategoriesParentDataFilter((prev) => [...prev, e]));
    };

    const handleFilterCategoryChlid = async () => {
        const params = [ {"status" : "sub"} ];
        const categoriesDataFilter = await GetCategoriesData(1, params);
        setCategoriesChildDataFilter([]);
        categoriesDataFilter.data.map((e) => setCategoriesChildDataFilter((prev) => [...prev, e]));
    };

    const searchCategoryParent = async (param) => {
        const params = [ {"name": param},{"status" : "main"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesParentDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesParentDataFilter((prev) => [...prev, e]));
        }
    };

    const searchCategoryChild = async (param) => {
        const params = [ {"name": param},{"status" : "sub"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesChildDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesChildDataFilter((prev) => [...prev, e]));
        }
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deleteAdsForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    // --- BOOST ACTIONS ---
    const openBoostConfirmation = (ad) => {
        setDurationDays(1);
        setBoostConfirmation({ 
            isOpen: true, 
            idToBoost: ad?.id, 
            title: ad?.title, 
            userName: ad?.full_name || "N/A", 
            isBoosted: ad?.is_boosted, 
            countDays: ad?.count_days, 
            startDate: ad?.boost_start_time, // Adjust key based on your API response
            endDate: ad?.boost_end_time      // Adjust key based on your API response
        });
    };

    const closeBoostConfirmation = () => {
        setBoostConfirmation({ isOpen: false, idToBoost: null });
        setDurationDays(1);
    };

    const handleBoostSubmit = async (e) => {
        e.preventDefault();
        if (boostConfirmation.idToBoost) {
            setLoadingBoost(true);
            try {
                const payload = { duration_days: durationDays };
                
                const result = await boostAdsForm(boostConfirmation.idToBoost, payload);
                if (result) {
                    handleApi(); // Refresh the table
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoadingBoost(false);
                closeBoostConfirmation();
            }
        }
    };

    const openOrderDetails = async (id) => {
        setOpenDetails({ isOpen: true, idToOpen: id });
        const adDetails = await GetAdByIdData(id);
        setAdsDetails({})
        setAdsDetails(adDetails);
    };

    const onClose = () => {
        setOpenDetails({ idToOpen : null, isOpen : false })
        setAdsDetails({});
    };

    const openCloseExportDialog = (e) => {
        setShowExportDialog(e);
    };

    const ExportTableWithPaginiation = async (e) => {
        const exportData = await GetAdsExportData(e, params);
        setExportData([]);
        exportData.data.map((e) => setExportData((prev) => [...prev, e])); 
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            <div className="">
                <AdsFilter searchCategoryParent={searchCategoryParent} searchCategoryChild={searchCategoryChild} categoriesChildData={categoriesChildDataFilter} categoriesParentData={categoriesParentDataFilter} typeOfcurrency={typeOfcurrency} typeOfAds={typeOfAds} typeOfUsers={typeOfUsers} values={params}/>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly justify-between px-5 py-5 gap-4">
                <h1 className="text-white text-lg ">{t("nav.ads")}</h1>
                <div className="flex gap-2">
                    {
                        location.pathname.startsWith("/users/details/") ?
                            <div onClick={()=>navigate("/ads/add", { state: { id: location.pathname.split("/")[3], name: userName } })}>
                                <Button background="#D06421" borderRadius="8px" border="border border-secondary" color="white" padding="8px 24px" text={currentLang === "en" ? "Add Ad" : "إضافة إعلان"} icon={<MdAddCircleOutline />} />
                            </div>
                        :
                            <div onClick={()=>navigate("/ads/add")}>
                                <Button background="#D06421" borderRadius="8px" border="border border-secondary" color="white" padding="8px 24px" text={currentLang === "en" ? "Add Ad" : "إضافة إعلان"} icon={<MdAddCircleOutline />} />
                            </div>
                    }
                    <div onClick={()=>openCloseExportDialog(true)}>
                        <Button background="#232424" borderRadius="8px" border="border border-gray-500/80" color="white" padding="8px 24px" text={t("button.export")} icon={<MdOutlineFileUpload />} />
                    </div>
                </div>
            </div>
            
            { (adsData?.length > 0 || isLoading) &&
                <div>
                    {isLoading ? <TableSkeleton cols={adsColumns}/> : (  
                        <Table 
                            name={"Ads"} 
                            showExportDialog={showExportDialog} 
                            openCloseExportDialog={openCloseExportDialog} 
                            ExportTableWithPaginiation={ExportTableWithPaginiation} 
                            rowsExportPaginiation={exportData} 
                            columns={adsColumns} 
                            rows={adsData} 
                            action="detailsAds" 
                            openDeleteConfirmation={openDeleteConfirmation} 
                            openOrderDetails={openOrderDetails} 
                            edit="/ads/edit" 
                            openBoostConfirmation={openBoostConfirmation}
                        />
                    )}
                </div>
            }
            { (adsData.length < 1 && !isLoading) &&
                <div>
                    <NotData />
                </div>
            }
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>

            {/* Existing Modals */}
            {deleteConfirmation.isOpen && <DeleteRecord ref={deleteRef} loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
            {openDetails.isOpen && openDetails.idToOpen && <AdsDetailsPop ref={adsRef} data={adsDetails} onClose={onClose} />}

            {/* --- NEW BOOST MODAL --- */}
            {boostConfirmation.isOpen && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
                    <div ref={boostRef} className="bg-thirdly rounded-2xl shadow-lg w-full max-w-md p-6 relative border border-gray-700">
                        
                        <button onClick={closeBoostConfirmation} className="absolute top-3 right-4 text-gray-400 hover:text-red-500 text-lg">✕</button>
                        
                        <h2 className="text-white text-xl font-bold mb-4">
                            {currentLang === "en" ? "Boost Advertisement" : "ترويج الإعلان"}
                        </h2>

                        {/* Info Box */}
                        <div className="bg-black/20 p-4 rounded-xl mb-4 text-sm border border-gray-700">
                            <p className="text-gray-300 mb-1">
                                <span className="text-gray-500">{currentLang === "en" ? "Ad Title: " : "عنوان الإعلان: "}</span>
                                <span className="text-white font-medium">{boostConfirmation.title}</span>
                            </p>
                            <p className="text-gray-300 mb-1">
                                <span className="text-gray-500">{currentLang === "en" ? "User: " : "المستخدم: "}</span>
                                <span className="text-white">{boostConfirmation.userName}</span>
                            </p>
                            <p className="text-gray-300 mb-1">
                                <span className="text-gray-500">{currentLang === "en" ? "Status: " : "الحالة: "}</span>
                                <span className={boostConfirmation.isBoosted ? "text-green-400" : "text-yellow-400"}>
                                    {boostConfirmation.isBoosted ? (currentLang === "en" ? "Currently Boosted" : "مروج حالياً") : (currentLang === "en" ? "Not Boosted" : "غير مروج")}
                                </span>
                            </p>
                            <p className="text-gray-300 mb-1">
                                <span className="text-gray-500">{currentLang === "en" ? "Count Days: " : "عدد الأيام: "}</span>
                                <span className="text-white">{boostConfirmation.countDays}</span>
                            </p>
                            {(boostConfirmation.startDate && boostConfirmation.endDate) && (
                                <p className="text-gray-400 text-xs mt-2">
                                    {boostConfirmation.startDate} → {boostConfirmation.endDate}
                                </p>
                            )}
                        </div>
                        
                        <form onSubmit={handleBoostSubmit}>
                            <div className="mb-6">
                                <label className="block text-gray-300 text-sm font-semibold mb-2">
                                    {currentLang === "en" ? "Duration (Days)" : "مدة الترويج (أيام)"}
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    required
                                    value={durationDays}
                                    onChange={(e) => setDurationDays(e.target.value)}
                                    className="w-full px-4 py-2 bg-black/20 border border-gray-600 focus:border-secondary rounded-lg text-white outline-none"
                                />
                                <p className="text-gray-500 text-xs mt-2">
                                    {currentLang === "en" ? "Set 0 to stop boosting" : "قم بتعيين 0 لإيقاف الترويج"}
                                </p>
                            </div>
                            
                            <div className="flex justify-end gap-3">
                                <button type="button" onClick={closeBoostConfirmation} className="px-4 py-2 text-gray-300 border border-gray-600 rounded-lg hover:bg-gray-800">
                                    {currentLang === "en" ? "Cancel" : "إلغاء"}
                                </button>
                                <button type="submit" disabled={loadingBoost} className="bg-secondary text-white px-5 py-2 rounded-lg hover:bg-orange-600 disabled:opacity-50">
                                    {loadingBoost ? (currentLang === "en" ? "Processing..." : "جاري المعالجة...") : (currentLang === "en" ? "Confirm" : "تأكيد")}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};